<div class="subBlockContainer componentContainer">
  <div class="subBlockContent componentContent">
     
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
            {{title}} - {{reportType}}
        </div>
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="top-divider"></div>
      <div class="inner-subBlock-wrapper">
            <div style="font-size:1.5rem;" class="heading">REVIEW:</div>
            <div class="sub-container">
              <div class="heading">COLUMNS:</div>
              <div class="row columns">
                <div class="tableContainer">
                  <table>
                    <tr *ngIf="selectedCols.length < 5 ">
                      <th class="tableHeader" *ngFor="let col of selectedCols">
                        {{col}}
                      </th>
                    </tr>
                    <tr *ngIf="selectedCols.length >= 6 ">
                      <th class="tableHeader">{{selectedCols[0]}}</th>
                      <th class="tableHeader">{{selectedCols[1]}}</th>
                      <th class="tableHeader" >{{selectedCols[2]}}</th>
                      <th class="tableHeader" ><div [ngbTooltip]="tipContent" placement="bottom">...</div></th>
                      <th class="tableHeader">{{selectedCols[selectedCols.length-1]}}</th>
                    </tr>
                    <tr >
                      <td class="tableHeader" *ngFor="let col of selectedCols | slice:0:5"><br></td>
                    </tr>
                    <tr >
                      <td class="tableHeader" *ngFor="let col of selectedCols | slice:0:5"><br></td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="heading">FILTERS:</div>
              <div class="row filterList">
                <div class="tableContainer">
                  <table>
                    <tr>
                      <th class="tableHeader">TYPE</th>
                      <th class="tableHeader">VALUE</th>
                      <th class="tableHeader">ADDITIONAL INFORMATION</th>
                    </tr>
                    <tr *ngFor="let filter of currentFilters">
                      <td>{{filter.type}}</td>
                      <td>{{filter.value}}</td>
                      <td><div *ngIf="filter.type=='REPORTING PERIOD' && filter.value=='SPECIFIC DATES'">START DATE: {{filter.startDate}} <br>END DATE: {{filter.endDate}}</div></td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="heading">SCHEDULING:</div>
              <div class="row filterList">
                <div style="width: 100%">
                  <label >FREQUENCY: {{schedule.frequency}}</label>
                  <div style="margin-top:10px; margin-bottom:10px;" *ngIf="schedule.frequency=='ONCE'">
                      <label style="margin-left:10px">DATE: {{schedule.onceDate}}</label>
                  </div>
                  <div *ngIf="schedule.frequency=='WEEKLY'">
                    <label style="margin-left:10px; margin-top:10px; margin-bottom:10px;">DAYS THE EMAIIL WILL BE SENT (EACH WEEK):</label>
                    <div style=" display: flex; flex-direction: row;">
                      <div *ngFor="let days of schedule.daysOfWeek; let i=index">
                        <div style="margin-left:15px; margin-right: 10px;" *ngIf="days==true && i < 5" >{{daysOfTheWeek[i]}}</div>
                      </div>
                    </div>
                    <div style=" display: flex; flex-direction: row;">
                        <div *ngFor="let days of schedule.daysOfWeek; let i=index">
                          <div style="margin-left:15px; margin-right: 10px;" *ngIf="days==true && i >= 5" >{{daysOfTheWeek[i]}}</div>
                        </div>
                      </div>
                  </div>
                  <div *ngIf="schedule.frequency=='MONTHLY'">
                    <div *ngIf="schedule.monthSetting=='DAY'">
                        <label style="margin-left:10px; margin-top:10px; margin-bottom:10px;">DAYS THE EMAIL WILL BE SENT (EACH MONTH):</label>
                        <div style="display: flex; flex-direction: row; margin-bottom:10px;">
                          <div *ngFor="let days of schedule.daysOfMonth; let i=index">
                            <span style="margin-left:15px; margin-right: 10px;" *ngIf="days==true && i <= 10" >{{daysOfTheMonth[i]}}</span>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom:10px;">
                          <div *ngFor="let days of schedule.daysOfMonth; let i=index">
                            <span style="margin-left:15px; margin-right: 10px; " *ngIf="days==true && i > 10 && i <= 21" >{{daysOfTheMonth[i]}}</span>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom:10px;">
                          <div *ngFor="let days of schedule.daysOfMonth; let i=index">
                            <span style="margin-left:15px; margin-right: 10px; " *ngIf="days==true && i > 21" >{{daysOfTheMonth[i]}}</span>
                          </div>
                        </div>
                    </div>
                    <div *ngIf="schedule.monthSetting=='WEEK'">
                        <label style="margin-left:10px; margin-top:10px; margin-bottom:10px;">SPECIFIC DAYS THE EMAIL WILL BE SENT (EACH MONTH):</label>
                        <div style="display: flex; flex-direction: row;  margin-bottom:10px;">
                          <div  *ngFor="let month of schedule.monthSpecifics; let i=index">
                            <span style="margin-left:15px; margin-right: 10px;" *ngIf="month==true" >{{periodInMonth[i]}}</span>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row;  margin-bottom:10px;">
                          <div *ngFor="let days of schedule.daysOfWeek; let i=index">
                              <span style="margin-left:15px; margin-right: 10px;" *ngIf="days==true && i < 5" >{{daysOfTheWeek[i]}}</span>
                          </div>
                        </div>
                        <div style="display: flex; flex-direction: row;  margin-bottom:10px;">
                            <div *ngFor="let days of schedule.daysOfWeek; let i=index">
                                <span style="margin-left:15px; margin-right: 10px;" *ngIf="days==true && i >= 5" >{{daysOfTheWeek[i]}}</span>
                            </div>
                          </div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="button-container">
              <button id="submitButton" class="button button-red button-small" (click)="submit()">Submit</button>
            </div>
          </div>      
      </div>
    </div>
  </div>
</div>

<ng-template #tipContent>
<ul style="margin-left: -10px; margin-right: 5px;" *ngFor="let col of selectedCols">
<li>{{col}}</li>
</ul>
</ng-template>
